import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash/lang';
import {capitalize} from 'lodash/string';
import {toSnakeCase} from 'utils/common';


const FormErrors = ({errors}) => (
    <div className="form-errors">
        {
            !isEmpty(errors) && (
                Object.entries(errors).map(([k, err], idx) => (
                    <div key={idx} className="alert alert-danger">
                        {toSnakeCase(k).split('_').map(v => capitalize(v)).join(' ')}: {err}
                    </div>
                ))
            )
        }
    </div>
);

FormErrors.propTypes = {
    errors: PropTypes.object.isRequired,
};

export default FormErrors;
